import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { replace } from 'connected-react-router';

import { LINK_SERVICES_STEPS } from '.';
import { LoadingDots } from '../../../components';
import {
  selectAgencyByAppRouteParam,
  selectAppByRouteParam,
} from '../../../reducers/agency/agencySelectors';
import {
  getAppParamsForLink,
  verifyStepUpIdentity,
  storeLinkServiceData,
} from '../../../reducers/agency/linkService/linkServiceActions';
import { getMyApps } from '../../../reducers/agency/agencyActions';
import LinkServiceIdentityView from './LinkServiceIdentityView';

const LinkServiceIdentity = ({
  agency,
  app,
  link,
  getMyApps,
  getAppParamsForLink,
  verifyStepUpIdentity,
  storeLinkServiceData,
  replace,
}) => {
  useEffect(() => {
    if (!agency || !app) {
      getMyApps();
      return;
    }

    if (!link || !link.params || !link.params.length) {
      getAppParamsForLink({ app, agency });
    }
  }, [agency && agency.agencyId, app && app.appId]);

  const onSubmit = async (values, formikActions) => {
    const stepUpIdentityValues = {
      ...values,
      ...(values.ssn !== undefined ? { ssn: '' } : {}),
      ...(values.last4ssn !== undefined ? { last4ssn: '' } : {}),
    };

    try {
      await verifyStepUpIdentity(values, formikActions);
      await storeLinkServiceData({ stepUpIdentityValues });
      replace(
        `/link/${LINK_SERVICES_STEPS.STEP_UP_REVIEW_CONFIRM}/${app.appSlug}`
      );
    } catch {
      // Expected API/business errors are handled by form status and modals.
      // when the user is stuck on the same page due to an API error.
      formikActions.setErrors({});
      // Avoid rethrowing to prevent runtime overlay noise.
    } finally {
      formikActions.setSubmitting(false);
    }
  };

  if (!agency || !app || !link || !link.params || !link.params.length) {
    return <LoadingDots />;
  }

  return (
    <LinkServiceIdentityView
      agency={agency}
      app={app}
      appParams={link.params}
      initialValues={link.stepUpIdentityValues}
      onSubmit={onSubmit}
      onBack={() =>
        replace(`/link/${LINK_SERVICES_STEPS.STEP_UP_INTRO}/${app.appSlug}`)
      }
    />
  );
};

const mapStateToProps = (state, props) => ({
  link: state.agency.link,
  agency: selectAgencyByAppRouteParam(state, props),
  app: selectAppByRouteParam(state, props),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getMyApps,
      getAppParamsForLink,
      verifyStepUpIdentity,
      storeLinkServiceData,
      replace,
    },
    dispatch
  );

LinkServiceIdentity.propTypes = {
  link: PropTypes.object,
  agency: PropTypes.object,
  app: PropTypes.object,
  getMyApps: PropTypes.func.isRequired,
  getAppParamsForLink: PropTypes.func.isRequired,
  verifyStepUpIdentity: PropTypes.func.isRequired,
  storeLinkServiceData: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
};

const ConnectedLinkServiceIdentity = connect(
  mapStateToProps,
  mapDispatchToProps
)(LinkServiceIdentity);

const RouteForLinkServiceIdentity = () => (
  <Route
    path={`/link/${LINK_SERVICES_STEPS.ID}/:appSlug`}
    render={props => <ConnectedLinkServiceIdentity {...props} />}
  />
);

export default RouteForLinkServiceIdentity;
